export const environment = {
    production: true,
    apiUrl: 'https://synergyportal.net/api',
    domainName: 'synergyportal.net'
};
